import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

/**
 * Guard that prevents QuickActivated users from accessing certain routes.
 * Redirects QuickActivated users to quick-activate route.
 */
export const nonQuickActivatedGuard = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  const isQuickActivated = storageService.getSessionStorage('is_quick_activated') === true;

  if (isQuickActivated) {
    // Redirect QuickActivated users to quick-activate route
    router.navigate(['/quick-activate']);
    return false;
  }

  // Allow non-QuickActivated users to proceed
  return true;
};
